import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Tooltip } from '@codex-brightworld/basics';
import { Icon } from '@codex-brightworld/icons';
import InformationTooltipRenderer from './InformationTooltipRenderer';

const StyledTooltip = styled(Tooltip)`
  display: none;
  position: absolute;
  left: 0px;
  top: 0px;
  
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
     /* IE10+ CSS styles go here */
     left: 29px;
  }
  
  @supports (-ms-accelerator:true) {
    /* IE Edge 12+ CSS styles go here */ 
    left: 40px;
  }
  
  max-width: 340px;
  z-index: 10;   
  margin-bottom: 10px;
  transform: ${(props) => {
    if (props.displayError) {
      return 'translate(7px, 95px)';
    }
    return 'translate(7px, 45px)';
  }};
  
  @media ${(props) => props.theme.breakpoints.mobile} {
    display: ${(props) => (!props.isDisplayed ? 'none' : 'inline-block')};
  }
  
  div {
    left: 282px;
  }
  span {
    background-color: #fff;
  }
`;

const StyledAlertContent = styled.div`
    font-family: CurrysSans;
    font-size: 14px;
    color: #222222;  
    background-color: #fff;
    padding: 8px 8px 1px 8px;
`;

const StyledContent = styled.div`
    p {
      margin: 0 0 7px 0;
    }
    li {
      margin: 0 0 7px 0;
    }
    a {
      color: ${(props) => props.theme.colors.primary.purple};
    }
    padding: 0 2px 0 2px;
`;

const StyledIconWrapper = styled.div`
  text-align: right;
  cursor: pointer;
  color: #4c12a1;
`;

const StyledIcon = styled(Icon)`
  && {
    margin: -3px -2px 6px 0px;
    width: 16px;
    height: 10px;
  }
  
  svg path:last-child {
    stroke: none;
    fill: ${(props) => props.theme.colors.primary.purple};
  }
`;

const InformationTooltipMobile = ({
  tooltipHtml, isDisplayed, onCloseClick, displayError
}) => {
  const renderedHtml = InformationTooltipRenderer.getRenderedHtml(tooltipHtml);

  return (
    <StyledTooltip
      isDisplayed={isDisplayed}
      arrow={'top'}
      type={'info'}
      displayError={displayError}
    >
      <StyledAlertContent>
        <StyledIconWrapper onClick={onCloseClick}>
          <StyledIcon icon={'close'} />
        </StyledIconWrapper>
        <StyledContent>
          {renderedHtml}
        </StyledContent>
      </StyledAlertContent>
    </StyledTooltip>
  );
};

InformationTooltipMobile.propTypes = {
  tooltipHtml: PropTypes.string.isRequired,
  isDisplayed: PropTypes.bool.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  displayError: PropTypes.bool.isRequired
};

export default InformationTooltipMobile;
